import { IPublicProfileActionService, PUBLIC_PROFILE_ACTION } from "../IPublicProfileActionService";
import { Injectable } from "@angular/core";
import {
  Serializer,
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { Observable, Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PublicProfileReplicaActionService implements IPublicProfileActionService {
  protected broker: ClientMessageBroker;
  protected _serializer: Serializer = new CubiqTS.CubiqSerializer();

  protected _updateSubjectMap = new Map<string, Set<Subject<string>>>();

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(PUBLIC_PROFILE_ACTION, true, true);
  }

  savePublicProfile(
    profileName: string,
    layout: string,
    overWriteExisting: boolean,
  ): Promise<CubiqTS.ErrorsImpl | null> {
    let req = new UiArguments("savePublicProfile");
    let arg1 = new FnArg(profileName, PRIMITIVE);
    let arg2 = new FnArg(layout, PRIMITIVE);
    let arg3 = new FnArg(overWriteExisting, PRIMITIVE);
    req.args = [arg1, arg2, arg3];
    return this.broker.runOnService(req, PRIMITIVE);
  }

  /**
   * Switch the profile for the current user to the specified profile. This should result in the
   * user session being immediately terminated on success
   * @param profile
   * @returns
   */
  public switchProfile(profile: CubiqTS.PlatformProfileImpl): Promise<void> {
    return Promise.reject();
  }
}
